import generic from './generic'

const getDefaultState = () => {
  return {
    all: [],
    errored: false,
    loading: false,
    fetchedAt: null,
  }
}

const state = getDefaultState()

const mutations = {
  ...generic.mutations,
  'RESET': function (state) {
    Object.assign(state, getDefaultState())
  },
}

const actions = {
  ...generic.actions,
  getAll (context) {
    return generic.getAll(context, {url: '/alliance/like/'})
  },
  backgroundRefresh (context) {
    return generic.getAll(context, {url: '/alliance/like/', hideLoading: true})
  },
}

const getters = {
  ...generic.getters,
    hasLiked: (state) => (like) => {
      return state.all.find((obj) => {
        return obj.object_id == like.object_id && obj.content_type.app_label == like.app && obj.content_type.model == like.model
      })
    },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
